import { Component, Input, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ImageTransformationService } from '@vendasta/image-transformation';
import { SanitizeCheckboxLabelPipe } from './field-checkbox';

@Component({
  selector: 'store-order-field',
  styleUrls: ['./field.component.scss'],
  templateUrl: './field.component.html',
  providers: [SanitizeCheckboxLabelPipe],
  standalone: false,
})
export class FieldComponent {
  @Input() field: any; // avoid checking union type in template
  @Input() form: FormGroup;
  readonly MAX_FILE_SIZE = 26214400; // 25MB

  @ViewChild('glxyUploader') glxyUploader;

  constructor(private imageTransformationService: ImageTransformationService) {}

  get isValid(): boolean {
    return this.form.controls[this.field.id].valid || this.form.controls[this.field.id].pristine;
  }

  showCheckboxError(field): boolean {
    return (
      this.form.controls[field].errors && this.form.controls[field].errors.required && this.form.controls[field].touched
    );
  }

  getValue(): any {
    return this.form.controls[this.field.id].value;
  }

  dropdownAnswer(): string {
    const answer = this.getValue();
    return ((this.field.options || []).find((option) => option.value === answer) || { label: answer }).label;
  }

  multidropdownAnswer(): string {
    const answer = this.getValue();
    return (answer || [])
      .map((a) => ((this.field.options || []).find((option) => option.value === a) || { name: a }).name)
      .join(', ');
  }

  checkboxAnswer(): string {
    const answer = this.getValue();
    return answer ? 'Yes' : 'No';
  }

  fileUploadAnswer(): string {
    const answer = this.getValue() || [];
    return answer.map((a) => (a.name ? a.name : a.url ? a.url : a)).join(', ');
  }

  // Handle deleting file from both galaxy uploader component, and order-form form values
  deleteFile(event: any): void {
    const filterOutDeletedFile = this.form.controls[this.field.id].value.filter(
      (file) => file.name !== event.name && file.url !== event.url,
    );

    this.form.controls[this.field.id].setValue(filterOutDeletedFile);
    // Tell galaxy uploader about delete so it can handle maxFiles properly
    this.glxyUploader.deleteFile(event);
  }

  // Manually update order-form form with events from galaxy file uploader
  onUpload(event: any): void {
    const uploadedFiles = this.form.controls[this.field.id].value;
    let fileUrl = event.url;
    // retain original scale for images
    if (this.imageTransformationService.isServingUrl(event.url)) {
      fileUrl += '=s0';
    }

    uploadedFiles.push({
      name: event.name,
      url: fileUrl,
    });

    this.form.controls[this.field.id].setValue(uploadedFiles);
  }
}
